export default "__VITE_ASSET__tbflrAAb__"